export default __webpack_public_path__ + "static/media/Love.63206aa1.gif";